export enum PortalType {
	MASTERS = 'masters',
	BACHELORS = 'bachelors',
	PHD = 'phd',
	SHORT_COURSES = 'short_courses',
	DISTANCE_LEANING = 'distance_learning',
}
